import { useEffect, useState } from 'react';

/**
 * Откладывает значение на delay мс. Нужен поиску: без него каждый
 * набранный символ уходил бы отдельным запросом на бэк.
 */
export function useDebouncedValue<T>(value: T, delay = 400): T {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const timer = window.setTimeout(() => setDebounced(value), delay);

        return () => window.clearTimeout(timer);
    }, [value, delay]);

    return debounced;
}
